import { request } from './core.api';

export interface ContractorDto {
  id: string;
  name: string;
  trade?: string;
  phoneNumber?: string;
  email?: string;
  notes?: string;
  createdAt: string;
}

export interface CreateContractorRequest {
  name: string;
  trade?: string;
  phoneNumber?: string;
  email?: string;
  notes?: string;
}

export interface UpdateContractorRequest {
  name: string;
  trade?: string;
  phoneNumber?: string;
  email?: string;
  notes?: string;
}

export const contractorsApi = {
  getAll: () => request<ContractorDto[]>('/contractors'),
  getById: (id: string) => request<ContractorDto>(`/contractors/${id}`),
  create: (data: CreateContractorRequest) => request<ContractorDto>('/contractors', { method: 'POST', body: JSON.stringify(data) }),
  update: (id: string, data: UpdateContractorRequest) => request<ContractorDto>(`/contractors/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: (id: string) => request<void>(`/contractors/${id}`, { method: 'DELETE' }),
};
